import { render, staticRenderFns } from "./EditPartner.vue?vue&type=template&id=10cccd40&scoped=true&"
import script from "./EditPartner.vue?vue&type=script&lang=js&"
export * from "./EditPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cccd40",
  null
  
)

export default component.exports